import axios from 'axios';
import { API_RESULT_CD, CommonResult, consoleApiLog, OK } from '../Common';

const endpoint = process.env.REACT_APP_API_URL;
const url = `${endpoint}/session`;

export interface SessionRequest {
  userId: string;
}

export interface RegisterSessionResponse {
  result: boolean;
}

export async function registerSession(request: SessionRequest): Promise<RegisterSessionResponse> {
  try {
    const response = await axios.put(url, request, { withCredentials: true });

    switch (response.status) {
      case OK.status:
        return {
          result: response.data.result,
        };
      default:
        throw new Error();
    }
  } catch (error) {
    return {
      result: false,
    };
  }
}

export interface JudgeSessionResponse {
  result: boolean;
}

// デバッグ用. 指定時間動作を停止する
export const sleep = (time: number) => new Promise((resolve) => setTimeout(resolve, time));

export async function judgeSession(request: SessionRequest): Promise<JudgeSessionResponse> {
  try {
    const response = await axios.get(`${url}?userId=${request.userId}`, { withCredentials: true });

    switch (response.status) {
      case OK.status:
        return {
          result: response.data.result,
        };
      default:
        throw new Error();
    }
  } catch (error) {
    return {
      result: false,
    };
  }
}
interface DeleteSessionResult {
  deleteSessionResult: boolean;
  userId: string;
}

export interface RemoveSessionResponse {
  result: Result;
  deleteResult?: DeleteSessionResult;
}

export async function removeSession(request: SessionRequest): Promise<string> {
  try {
    const response = await axios.request({
      method: 'delete',
      url,
      data: request,
    });

    switch (response.status) {
      case OK.status:
        return response.data.result.resultCd;
      default:
        throw new Error();
    }
  } catch (error) {
    return API_RESULT_CD.ERROR;
  }
}

// deprecateしたい。
export function judgeSessionInterceptor(userId: string, resolve: (res: JudgeSessionResponse) => void, reject: (res?: string) => void) {
  axios.interceptors.request.use((config) => {
    consoleApiLog(config.url || '', 'FETCHING', config.method, config.data);
    if (config.url?.includes('/session')) {
      return config;
    }
    return judgeSession({ userId: userId }).then((res: JudgeSessionResponse) => {
      if (res.result) {
        resolve(res);
        return config;
      } else {
        const errorMessage = 'message';
        reject(errorMessage);
        return Promise.reject(errorMessage);
      }
    });
  });

  axios.interceptors.response.use(
    (response) => {
      if (response) consoleApiLog(response.config.url || '', 'SUCCESS', response.config.method, response);

      return response;
    },
    (error) => {
      if (error.response) consoleApiLog(error.response.config.url || '', 'ERROR', error.response.config.method, error.response);

      return Promise.reject(error);
    }
  );
}
